import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Inject,
  Input,
  OnInit,
  Output,
  ChangeDetectionStrategy
} from "@angular/core";
import {Client as ConversationsClient, Conversation, Message, Paginator} from "@twilio/conversations";
import {ChatHttpService} from "../../services/chat-http.service";
import {CurrentSiteContextService} from "../../../commons/angular/services/current-site-context.service";

require('./chat-conversations-list.scss');
@Component({
  standalone: false,
  selector: 'chat-conversations-list',
  templateUrl: './chat-conversations-list.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ChatConversationsListComponent implements OnInit {

  @Input() conversations: Conversation[];
  @Output() onUserSelect: EventEmitter<Conversation> = new EventEmitter();
  @Output() onConversationSelect: EventEmitter<Conversation> = new EventEmitter();
  @Output() onClose: EventEmitter<Conversation> = new EventEmitter();

  public query: string;
  public conversationsPaginator: Paginator<Conversation>
  // public conversations: Conversation[];
  private siteId: string;

  constructor(
    @Inject(ChatHttpService) private chatHttpService: ChatHttpService,
    @Inject(CurrentSiteContextService) private currentSiteContextService: CurrentSiteContextService,
    @Inject(ChangeDetectorRef) private changeDetectorRef: ChangeDetectorRef
  ) {
  }

  ngOnInit(): void {
    this.siteId = this.currentSiteContextService.currentSiteId;
    // this._getSubscribedConversations();
  }

  onSelect(conversation) {
    this.onConversationSelect.emit(conversation);
  }

  onMessageAdded(conversation: Conversation) {
    this.conversations = this.conversations.map((c: Conversation) => {
      if (conversation.sid === c.sid) {
        if (c.lastMessage) {
          c.lastMessage.dateCreated = new Date();
        }
      }
      return c;
    })
    this._checkDetector();
  }

  identify(index, conversation: Conversation) {
    return conversation.sid;
  }

  private _checkDetector() {
    this.changeDetectorRef.detectChanges();
  }

}
